// theme constant
export const gridSpacing = 2;
export const gridSpacingLg = 2;
export const drawerWidth = 240;
export const paddingSm = 8;
export const paddingMd = 32;
export const paddingLg = 64;
export const frontendDrawerWidth = '100vw';
